module.exports = __webpack_public_path__ + "static/media/Baslik.314da4be.png";